export const isDevEnv = import.meta.env.DEV;
export const isHomologEnv = window.location.href.indexOf('lkp.dev.br') > -1;
export const isProductionEnv = import.meta.env.PROD;
